<template>
  <div>
    <h2>Actividad</h2>
    <p>Por favor seleccione su rol dentro del mercado.</p>
    <div class="markets">

      <div class="roles">
        <button data-test="seller-btn" class="sell" :class="{selected: market.sell}" @click="toggleSell(); errorMsg=''">Soy vendedor</button>
        <button data-test="buyer-btn" class="buy" :class="{selected: market.buy}" @click="toggleBuy(); errorMsg=''">Soy comprador</button>
      </div>
    </div>
    <p class="validation-error-message" v-if="errorMsg">{{ this.errorMsg }}</p>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapActions, mapState, mapMutations } from 'vuex'

const rolesQuery = gql`
    query fetchRoles($names: [String!]) {
      fetchRoles(names: $names) {
        name
        id
      }
    }
  `

export default {
  name: 'signup-market-rol',
  data () {
    return {
      errorMsg: ''
    }
  },
  computed: mapState({
    market: state => state.SignUp.market
  }),
  beforeMount () {
    this.getRoles()
    this.setMarket({
      name: 'Porcinos',
      icon: '3d_rotation',
      sell: false,
      buy: false
    })
  },
  methods: {
    ...mapMutations('SignUp', [
      'setMarket',
      'setRoles'
    ]),
    readyForNext () {
      if (this.market.buy || this.market.sell) {
        return true
      } else {
        this.errorMsg = 'Debe seleccionar al menos una opción'
        return false
      }
    },
    ...mapActions('SignUp', {
      toggleBuy: 'toggleMarketRolBuy',
      toggleSell: 'toggleMarketRolSell'
    }),
    getRoles () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(rolesQuery),
        variables: {
          names: []
        }
      }}).then(res => {
        this.setRoles(res.data.data.fetchRoles)
      }).catch((err) => {
        console.log(err.message)
      })
    }
  }
}
</script>

<style>

</style>
